/* istanbul ignore file */

import StoryTheme from './Story'
import BlogTheme from './Blog'

// List of available themes
export const themes = {
  story: StoryTheme,
  blog: BlogTheme,
  default: BlogTheme,
}

export default themes
